import APIConstants from "../connection/APIConstants";
import APIManager from "../connection/APIManager";
import CacheLoadCredentials from "./CacheLoadCredentials";

/*
USE CASE: AuthCheckLogin
Desc: It checks on the API if this (USER / TOKEN) are valid and authorized 
params: NONE
returns:
    - A promise that resolves if the userData stored in cache exists, 
    and its values are valid and authorized. If not it will be rejected
*/

const AuthCheckLogin = () => {
    return new Promise(async (resolve, reject) => {
        //Checking if there is login data stored
        let userData = await CacheLoadCredentials()
        //If not reject
        if(!userData || !userData.email || !userData.token) return reject()
                
        //Checking email/token on API
        let body = {}
        body["email"] = userData.email
        body["token"] = userData.token
        //body["tipo"] = userData.tipo //Must add tipo for security issues

        APIManager.send("/auth","POST",{},body).then(res => {
            resolve(userData)        
        }).catch(e => {
            reject()
        })
    })
}
export default AuthCheckLogin;